import { apiCall, apiCallWithAuthWithReturn, apiCallWithReturn } from "../utils/commonUtils";

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (email, password) => {
  try {
    const url= `${API_URL}/auth/login`;
    const reqData =JSON.stringify({ email, password });
    const response = await apiCallWithReturn(url, "POST",reqData,{},{});
    const data = response?.data||{};
    if (response?.status){
      return { success: response.status, token: data.token };
    } else {
      return { success: false, message: response.message || "Login failed" };
    }
  } catch (error) {
    console.error("Login error:", error);
    return { success: false, message: "Network error" };
  }
};

export const register = async (registrationData) => {
  try {
    const url= `${API_URL}/auth/register`;
    const reqData =JSON.stringify(registrationData);
    const response = await apiCallWithReturn(url, "POST",reqData,{},{});
    const data = response?.data||{};
    if (response?.status){
      return { success: response.status, message: "Registration successful",data };
    } else {
      return { success: false, message: response.message || "Registration failed" };
    }
  } catch (error) {
    console.error("Registration failed:", error);
    return { success: false, message: "Registration failed" };
  }
};

export const sendOtp = async (phoneNumber) => {
  try {
    const url= `${API_URL}/auth/generateOTP`;
    const reqData =JSON.stringify({phoneNumber});
    return await apiCallWithReturn(url, "POST",reqData,{},{});
  } catch (error) {
    console.error("Error sending OTP:", error);
    return { status: false, message: "Error sending OTP" };
  }
};

export const sendOTPForForgotPassword = async (phoneNumber) => {
  try {
    const url= `${API_URL}/auth/generateOTPForForgotPassword`;
    const reqData =JSON.stringify({phoneNumber});
    return await apiCallWithReturn(url, "POST",reqData,{},{});
  } catch (error) {
    console.error("Error sending OTP:", error);
    return { status: false, message: "Error sending OTP" };
  }
};

export const verifyOtp = async (phoneNumber, otp) => {
  try {

    const url= `${API_URL}/auth/verifyOTP`;
    const reqData =JSON.stringify({phoneNumber,otp});
    const response = await apiCallWithReturn(url, "POST",reqData,{},{});
    if (response?.status) {
      return response.data;
    } else {
      return { success: response.status, message: response.message };
    }
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return { success: false, message: "Error verifying OTP" };
  }
};

export const verifyOTPForgotPassword = async (phoneNumber, otp) => {
  try {

    const url= `${API_URL}/auth/verifyOTPForgotPassword`;
    const reqData =JSON.stringify({phoneNumber,otp});
    return await apiCallWithReturn(url, "POST",reqData,{},{});
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return { status: false, message: "Error verifying OTP" };
  }
};

export const verifyUserOtp = async (phoneNumber, otp) => {
  try {
    const url= `${API_URL}/auth/verifyDoctorOTP`;
    const reqData =JSON.stringify({phoneNumber,otp});
    const response = await apiCallWithReturn(url, "POST",reqData,{},{});    
    if (response?.status) {
      return response.data;
    } else {
      return { success: response.status, message: response.message };
    }
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return { success: false, message: "Error verifying OTP" };
  }
};

export const resetPassword = async (data) => {
  try {
    const url= `${API_URL}/auth/resetPassword`;
    const reqData =JSON.stringify(data);
    return await apiCallWithReturn(url, "POST",reqData,{},{});
  } catch (error) {
    console.error("Error changing password:", error);
    return { status: false, message: "Error changing password" };
  }
};

export const changePassword = async (data) => {
  try {
    const url= `${API_URL}/auth/changePassword`;
    const reqData =JSON.stringify(data);
    return await apiCallWithAuthWithReturn(url, "POST",reqData,{},{});
  } catch (error) {
    console.error("Error changing password:", error);
    return { status: false, message: "Error changing password" };
  }
};